// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__1vpne","Icon":"Button_Icon__p23Bu","rotate":"Button_rotate__2xeFY","swing-in":"Button_swing-in__KhAiH"};